import {
  CHECKIN_PHOTO_JPEG_QUALITY,
  CHECKIN_PHOTO_MAX_DIMENSION,
  type CheckinPhotoRef,
} from '@awwyeah/shared';
import * as shared from '../../../lib/outbox/image';
import type { PreparedPhoto } from '../../../lib/outbox/image';

export type { PreparedPhoto } from '../../../lib/outbox/image';

/**
 * Check-in's photo pipeline, unchanged in behaviour since WS-13 — WS-20 pulled the actual
 * downscale/re-encode/hash mechanics out into `../../../lib/outbox/image.ts` (generic,
 * parameterized by max dimension + quality) so recipes' header-photo upload could reuse it
 * instead of forking this file. Every export and signature here is identical to before the
 * refactor, which is what keeps `test/checkin/image.test.ts` green untouched.
 */

export function scaleToFit(
  width: number,
  height: number,
  max = CHECKIN_PHOTO_MAX_DIMENSION,
): { width: number; height: number } {
  return shared.scaleToFit(width, height, max);
}

export const sha256Hex = shared.sha256Hex;
export const hasExifSegment = shared.hasExifSegment;

/** Runs the full pipeline on a camera capture or a library pick. */
export async function preparePhoto(file: Blob): Promise<PreparedPhoto> {
  return shared.preparePhoto(file, {
    maxDimension: CHECKIN_PHOTO_MAX_DIMENSION,
    quality: CHECKIN_PHOTO_JPEG_QUALITY,
  });
}

/** The Yjs `photoRef` for a freshly prepared photo: on this device only, for now. */
export function localPhotoRef(photo: PreparedPhoto): CheckinPhotoRef {
  return { id: photo.id, w: photo.width, h: photo.height, state: 'local' };
}
